import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=688f2cb8&scoped=true"
import script from "./Final.vue?vue&type=script&lang=ts"
export * from "./Final.vue?vue&type=script&lang=ts"
import style0 from "./Final.vue?vue&type=style&index=0&id=688f2cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f2cb8",
  null
  
)

export default component.exports